export default {
  props: {
    modBordered: Boolean,
    modNaked: Boolean,
    modStacked: Boolean,
    modFull: Boolean,
    modInline: Boolean,
    modIndent: Boolean,
    modCondensed: Boolean,
    tagName: {
      type: String,
      default: 'table',
    },

  },
  computed: {
    classes() {
      return [
        'ba-table',
        {
          'ba-table--bordered': this.modBordered,
          'ba-table--naked': this.modNaked,
          'ba-table--stacked': this.modStacked,
          'ba-table--full': this.modFull,
          'ba-table--inline': this.modInline,
          'ba-table--condensed': this.modCondensed,
          'ba-table--indent': this.modIndent,
        },
      ];
    },
  },
};
